export default {
  getList: (state) => state.list,
  getDetail: (state) => state.detail,
  getPageInfo: (state) => state.pageInfo,
  getCondition: (state) => state.condition
};
